(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[52792],{

/***/ 31808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fk": function() { return /* binding */ detectFlexGapSupported; },
/* harmony export */   "jD": function() { return /* binding */ canUseDocElement; }
/* harmony export */ });
/* unused harmony export isStyleSupport */
/* harmony import */ var rc_util_es_Dom_canUseDom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98924);

var canUseDocElement = function canUseDocElement() {
  return (0,rc_util_es_Dom_canUseDom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)() && window.document.documentElement;
};
var isStyleSupport = function isStyleSupport(styleName) {
  if (canUseDocElement()) {
    var styleNameList = Array.isArray(styleName) ? styleName : [styleName];
    var documentElement = window.document.documentElement;
    return styleNameList.some(function (name) {
      return name in documentElement.style;
    });
  }

  return false;
};
var flexGapSupported;
var detectFlexGapSupported = function detectFlexGapSupported() {
  if (!canUseDocElement()) {
    return false;
  }

  if (flexGapSupported !== undefined) {
    return flexGapSupported;
  } // create flex container with row-gap set


  var flex = document.createElement('div');
  flex.style.display = 'flex';
  flex.style.flexDirection = 'column';
  flex.style.rowGap = '1px'; // create two, elements inside it

  flex.appendChild(document.createElement('div'));
  flex.appendChild(document.createElement('div')); // append to the DOM (needed to obtain scrollHeight)

  document.body.appendChild(flex);
  flexGapSupported = flex.scrollHeight === 1; // flex container should be 1px high from the row-gap

  document.body.removeChild(flex);
  return flexGapSupported;
};

/***/ }),

/***/ 80081:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/watchlist",
      function () {
        return __webpack_require__(2132);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_watchlist; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/antd/es/tooltip/index.js + 1 modules
var tooltip = __webpack_require__(56266);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/@deprecated-ui/watchlist/Tooltip.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Tooltip = (0,styled_components_browser_esm/* default */.ZP)(tooltip/* default */.Z).withConfig({
    componentId: "sc-be5fcd30-0"
})(_templateObject());
/* harmony default export */ var watchlist_Tooltip = (Tooltip);

// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
;// CONCATENATED MODULE: ./src/@deprecated-ui/watchlist/ConnectionIndicator.js

function ConnectionIndicator_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 50%;\n  height: ",
        ";\n  width: ",
        ";\n\n  background-color: ",
        ";\n"
    ]);
    ConnectionIndicator_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var sizes = {
    small: "8px",
    medium: "12px",
    large: "16px"
};
var ConnectionIndicator = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs(function(props) {
    return {
        size: props.size || "medium",
        isConnected: props.isConnected || false
    };
}).withConfig({
    componentId: "sc-84eb6caa-0"
})(ConnectionIndicator_templateObject(), function(param) {
    var size = param.size;
    return sizes[size];
}, function(param) {
    var size = param.size;
    return sizes[size];
}, function(param) {
    var isConnected = param.isConnected;
    return isConnected ? color/* default.primary */.Z.primary : color/* default.sunsetOrange */.Z.sunsetOrange;
});
/* harmony default export */ var watchlist_ConnectionIndicator = (ConnectionIndicator);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./src/utils/auth.js
var auth = __webpack_require__(14229);
// EXTERNAL MODULE: ./src/features/watchlist/styled.ts
var styled = __webpack_require__(62851);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
// EXTERNAL MODULE: ./node_modules/antd/es/dropdown/index.js + 2 modules
var dropdown = __webpack_require__(38504);
;// CONCATENATED MODULE: ./src/@deprecated-ui/watchlist/DropDown.js

function DropDown_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n"
    ]);
    DropDown_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Dropdown = (0,styled_components_browser_esm/* default */.ZP)(dropdown/* default */.Z).attrs(function(param) {
    var width = param.width;
    return {
        width: width || "unset"
    };
}).withConfig({
    componentId: "sc-63775cce-0"
})(DropDown_templateObject(), function(param) {
    var width = param.width;
    return width;
});
/* harmony default export */ var DropDown = (Dropdown);

// EXTERNAL MODULE: ./src/features/watchlist/Collection/ConfirmationModal.tsx
var ConfirmationModal = __webpack_require__(57547);
// EXTERNAL MODULE: ./src/features/watchlist/Collection/slice.ts
var slice = __webpack_require__(67266);
// EXTERNAL MODULE: ./src/features/watchlist/Collection/styled.ts + 1 modules
var Collection_styled = __webpack_require__(56005);
;// CONCATENATED MODULE: ./src/features/watchlist/Collection/EditWatchlist.tsx



// local feature



var actions = slice/* default.actions */.ZP.actions;
function EditWatchlist() {
    var ref = (0,es/* useSelector */.v9)(slice/* selectors */.wl), isCollectionLoading = ref.isCollectionLoading, modalVisible = ref.modalVisible, selectedForModify = ref.selectedForModify;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref1 = (0,react.useState)(selectedForModify.name), name = ref1[0], setName = ref1[1];
    var handleChange = function(e) {
        setName(e.target.value);
    };
    var onConfirmClick = function() {
        dispatch(slice/* thunks.editCompanyWatchlist */.CJ.editCompanyWatchlist({
            name: name,
            id: selectedForModify.watchlist_id
        }));
    };
    var onCancelClick = function() {
        dispatch(actions.handleSelectForModify({
            modalType: "none",
            selectedIndex: null
        }));
    };
    var title = 'Change watchlist name "'.concat(selectedForModify.name, '"');
    var isModalVisible = modalVisible === "edit";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmationModal/* default */.Z, {
        isVisible: isModalVisible,
        onCancel: onCancelClick,
        onConfirm: onConfirmClick,
        title: title,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Collection_styled/* Input */.II, {
            type: "text",
            value: name,
            onChange: handleChange,
            disabled: isCollectionLoading,
            maxLength: 25,
            size: "large",
            suffix: "".concat(name.length, "/25")
        })
    });
}
/* harmony default export */ var Collection_EditWatchlist = (EditWatchlist);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/features/watchlist/slice.ts
var watchlist_slice = __webpack_require__(25612);
;// CONCATENATED MODULE: ./src/features/watchlist/Collection/RemoveWatchlist.tsx
/* eslint-disable @typescript-eslint/ban-ts-comment */ 








var RemoveWatchlist_actions = slice/* default.actions */.ZP.actions;
function RemoveWatchlist() {
    var ref = (0,es/* useSelector */.v9)(slice/* selectors */.wl), modalVisible = ref.modalVisible, selectedForModify = ref.selectedForModify;
    var activeWatchlistId = (0,es/* useSelector */.v9)(watchlist_slice/* selectors */.wl).activeWatchlistId;
    var dispatch = (0,es/* useDispatch */.I0)();
    var loadAllWatchlist = function() {
        // @ts-ignore
        var ref = auth/* default.getUserAccess */.Z.getUserAccess(), wl = ref.watchlist_id;
        dispatch(watchlist_slice/* default.actions.handleChangeActiveWatchlist */.ZP.actions.handleChangeActiveWatchlist({
            selected: wl,
            name: "All Watchlist"
        }));
    };
    var onConfirmClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var del, data, isActive;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return dispatch(slice/* thunks.deleteCompanyWatchlist */.CJ.deleteCompanyWatchlist({
                            id: selectedForModify.watchlist_id
                        }));
                    case 2:
                        del = _ctx.sent;
                        data = del.payload.data;
                        isActive = selectedForModify.watchlist_id === activeWatchlistId;
                        if (data && isActive) {
                            loadAllWatchlist();
                        }
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onConfirmClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var onCancelClick = function() {
        dispatch(RemoveWatchlist_actions.handleSelectForModify({
            modalType: "none",
            selectedIndex: null
        }));
    };
    var title = "Remove Watchlist Collection";
    var isModalVisible = modalVisible === "delete";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmationModal/* default */.Z, {
        isVisible: isModalVisible,
        onCancel: onCancelClick,
        onConfirm: onConfirmClick,
        title: title,
        isBlock: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
            padding: "12px 16px",
            children: [
                'Are you sure want to remove "',
                selectedForModify.name,
                '"?'
            ]
        })
    });
}
/* harmony default export */ var Collection_RemoveWatchlist = (RemoveWatchlist);

// EXTERNAL MODULE: ./src/@deprecated-ui/watchlist/Button.js
var Button = __webpack_require__(12099);
;// CONCATENATED MODULE: ./src/utils/watchlist.ts

var transformWatchlistName = function(watchlistName) {
    if (watchlistName.toLowerCase().trim() === "all") {
        return "All Watchlist";
    }
    return watchlistName;
};
var checkDefaultWatchlist = function(watchlistId) {
    // @ts-ignore
    var ref = auth/* default.getUserAccess */.Z.getUserAccess(), defaultWatchlist = ref.watchlist_id;
    return Number(watchlistId) === Number(defaultWatchlist);
};
// eslint-disable-next-line import/prefer-default-export


;// CONCATENATED MODULE: ./src/features/watchlist/Collection/CollectionItem.tsx









var CollectionItem_actions = slice/* default.actions */.ZP.actions;
var rootActions = watchlist_slice/* default.actions */.ZP.actions;
function CollectionItem(param) {
    var _index = param.index, index = _index === void 0 ? 0 : _index, _name = param.name, name = _name === void 0 ? "All Watchlist" : _name, _watchlistid = param.watchlistid, watchlistid = _watchlistid === void 0 ? null : _watchlistid;
    var dispatch = (0,es/* useDispatch */.I0)();
    var onItemClick = function() {
        dispatch(rootActions.handleChangeActiveWatchlist({
            selected: watchlistid,
            name: name
        }));
        dispatch(CollectionItem_actions.handleSetDropdown({
            isOpen: false
        }));
    };
    var onEditItemClick = function(e) {
        e.stopPropagation();
        dispatch(CollectionItem_actions.handleSelectForModify({
            modalType: "edit",
            selectedIndex: index
        }));
    };
    var onDeleteItemClick = function(e) {
        e.stopPropagation();
        dispatch(CollectionItem_actions.handleSelectForModify({
            modalType: "delete",
            selectedIndex: index
        }));
    };
    var isEditable = !checkDefaultWatchlist(watchlistid);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        onClick: onItemClick,
        align: "center",
        justify: "space-between",
        style: {
            cursor: "pointer",
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                width: "100%",
                size: "14px",
                children: name
            }),
            isEditable && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                align: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                        className: "icon-toolbar_pencil",
                        onClick: onEditItemClick
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                        className: "icon-trading_delete",
                        hoverColor: color/* default.sunsetOrange */.Z.sunsetOrange,
                        onClick: onDeleteItemClick
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var Collection_CollectionItem = (CollectionItem);

;// CONCATENATED MODULE: ./src/features/watchlist/Collection/NewWatchlistForm.tsx










var NewWatchlistForm_actions = slice/* default.actions */.ZP.actions;
function NewWatchlistForm() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var isCollectionLoading = (0,es/* useSelector */.v9)(slice/* selectors */.wl).isCollectionLoading;
    var ref = (0,react.useState)(""), name = ref[0], setName = ref[1];
    var createWatchlist = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(wlName) {
            var ref, create, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (wlName) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        _ctx.next = 5;
                        return dispatch(slice/* thunks.createCompanyWatchlist */.CJ.createCompanyWatchlist({
                            name: wlName
                        }));
                    case 5:
                        create = _ctx.sent;
                        data = (ref = create.payload) === null || ref === void 0 ? void 0 : ref.data;
                        if (data) {
                            dispatch(watchlist_slice/* default.actions.handleChangeActiveWatchlist */.ZP.actions.handleChangeActiveWatchlist({
                                selected: data.watchlist_id,
                                name: data.name
                            }));
                            dispatch(NewWatchlistForm_actions.handleSetDropdown({
                                isOpen: false
                            }));
                        }
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function createWatchlist(wlName) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSaveClick = function() {
        createWatchlist(name);
    };
    var handleCancelClick = function() {
        dispatch(NewWatchlistForm_actions.handleSetFormOpen({
            isOpen: false
        }));
    };
    var handleNameChange = function(e) {
        setName(e.target.value);
    };
    var handlePressEnter = function(e) {
        var ref;
        var val = e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value;
        createWatchlist(val);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        direction: "column",
        width: "100%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Collection_styled/* Input */.II, {
                type: "text",
                placeholder: "Watchlist Name",
                value: name,
                onChange: handleNameChange,
                maxLength: 25,
                autoFocus: true,
                suffix: "".concat(name.length, "/25"),
                onPressEnter: handlePressEnter
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Collection_styled/* ButtonContainer */.qO, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        htmlType: "button",
                        onClick: handleCancelClick,
                        loading: isCollectionLoading,
                        block: true,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: handleSaveClick,
                        loading: isCollectionLoading,
                        type: "primary",
                        block: true,
                        children: "Save"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var Collection_NewWatchlistForm = (NewWatchlistForm);

;// CONCATENATED MODULE: ./src/features/watchlist/Collection/MenuOverlay.tsx









var MenuOverlay_actions = slice/* default.actions */.ZP.actions;
function MenuOverlay() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,es/* useSelector */.v9)(slice/* selectors */.wl), available = ref.available, isCollectionLoading = ref.isCollectionLoading, isFormOpen = ref.isFormOpen, activeId = ref.activeWatchlistId;
    var handleCreateClick = function() {
        dispatch(MenuOverlay_actions.handleSetFormOpen({
            isOpen: true
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Collection_styled/* MenuHeader */.ti, {
                children: "MY WATCHLIST COLLECTION"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Collection_styled/* Menu */.v2, {
                children: available.map(function(param, index) {
                    var name = param.name, id = param.watchlist_id, isDefault = param.is_default;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Collection_styled/* Menu.Item */.v2.Item, {
                        className: activeId === id && "active",
                        disabled: isCollectionLoading,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Collection_CollectionItem, {
                            index: index,
                            name: isDefault ? "All Watchlist" : name,
                            watchlistid: id
                        })
                    }, "menu-item-".concat(id));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                width: "100%",
                padding: "8px 8px",
                style: {
                    background: "white",
                    border: "1px solid rgb(218, 218, 218)",
                    borderTop: "none",
                    borderRadius: "0 0 3px 3px"
                },
                children: isFormOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Collection_NewWatchlistForm, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    onClick: handleCreateClick,
                    loading: isCollectionLoading,
                    type: "primary",
                    block: true,
                    children: "Create New Watchlist"
                })
            })
        ]
    });
}
/* harmony default export */ var Collection_MenuOverlay = (MenuOverlay);

;// CONCATENATED MODULE: ./src/features/watchlist/Collection/index.tsx











var Collection_actions = slice/* default.actions */.ZP.actions;
function DropdownMenu() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,es/* useSelector */.v9)(slice/* selectors */.wl), isDropdownOpen = ref.isDropdownOpen, needRefresh = ref.needRefresh, modalVisible = ref.modalVisible, activeWatchlistName = ref.activeWatchlistName;
    var dropdownToggle = function() {
        var isOpen = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !isDropdownOpen;
        dispatch(Collection_actions.handleSetDropdown({
            isOpen: isOpen
        }));
    };
    (0,react.useEffect)(function() {
        dispatch(slice/* thunks.fetchSavedCompanyWatchlist */.CJ.fetchSavedCompanyWatchlist({}));
    }, [
        dispatch
    ]);
    (0,react.useEffect)(function() {
        if (needRefresh) {
            dispatch(slice/* thunks.fetchSavedCompanyWatchlist */.CJ.fetchSavedCompanyWatchlist({}));
        }
    }, [
        dispatch,
        needRefresh
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDown, {
                width: "280px",
                trigger: [
                    "click"
                ],
                onVisibleChange: dropdownToggle,
                visible: isDropdownOpen,
                overlay: /*#__PURE__*/ (0,jsx_runtime.jsx)(Collection_MenuOverlay, {}),
                // @ts-expect-error
                destroyPopupOnHide: true,
                zIndex: 99,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    align: "center",
                    style: {
                        cursor: "pointer",
                        gap: "10px"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            family: "bold",
                            weight: "700",
                            children: activeWatchlistName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                            className: "icon-toolbar_down"
                        })
                    ]
                })
            }),
            modalVisible === "edit" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Collection_EditWatchlist, {}),
            modalVisible === "delete" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Collection_RemoveWatchlist, {})
        ]
    });
}
/* harmony default export */ var Collection = (DropdownMenu);

// EXTERNAL MODULE: ./src/global/MainLayout/slice.js
var MainLayout_slice = __webpack_require__(48153);
;// CONCATENATED MODULE: ./src/features/watchlist/index.tsx












var WatchlistTable = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(92961), __webpack_require__.e(92077), __webpack_require__.e(79931), __webpack_require__.e(76750), __webpack_require__.e(35851), __webpack_require__.e(70735), __webpack_require__.e(24513), __webpack_require__.e(67555), __webpack_require__.e(76219), __webpack_require__.e(54663), __webpack_require__.e(80708), __webpack_require__.e(91727), __webpack_require__.e(15068), __webpack_require__.e(21897), __webpack_require__.e(98141)]).then(__webpack_require__.bind(__webpack_require__, 60096));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(60096)
            ];
        }
    },
    ssr: false
});
var watchlist_actions = watchlist_slice/* default.actions */.ZP.actions;
function Watchlist() {
    // @ts-ignore
    var ref = (0,es/* useSelector */.v9)(watchlist_slice/* selectors */.wl), activeWatchlistId = ref.activeWatchlistId, connectionStatus = ref.connectionStatus, isExpand = ref.isExpand, isComposed = ref.isComposed;
    var dispatch = (0,es/* useDispatch */.I0)();
    var isSideWidgetOpen = (0,es/* useSelector */.v9)(MainLayout_slice/* selectors */.wl).isSideWidgetOpen;
    (0,react.useEffect)(function() {
        // @ts-ignore
        var ref = auth/* default.getUserAccess */.Z.getUserAccess(), wl = ref.watchlist_id;
        dispatch(watchlist_actions.handleChangeActiveWatchlist({
            selected: wl,
            name: "All Watchlist"
        }));
    }, [
        dispatch
    ]);
    var containerWidth = isSideWidgetOpen ? "100%" : "990px";
    if (isComposed) {
        containerWidth = "798px";
    } else if (isExpand) {
        containerWidth = "100%";
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            direction: "column",
            width: containerWidth,
            m: "auto",
            mt: "3px",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* Box */.xu, {
                    justify: "space-between",
                    align: "center",
                    // @ts-expect-error
                    p: "15px 12px",
                    width: "100%",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Collection, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(watchlist_Tooltip, {
                            title: "Connection Status: ".concat(connectionStatus),
                            placement: "left",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(watchlist_ConnectionIndicator, {
                                isConnected: connectionStatus,
                                size: "small"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Box */.xu, {
                    direction: "column",
                    my: "16px",
                    width: "100%",
                    children: activeWatchlistId && /*#__PURE__*/ (0,jsx_runtime.jsx)(WatchlistTable, {})
                })
            ]
        })
    });
}
/* harmony default export */ var watchlist = (Watchlist);

// EXTERNAL MODULE: ./src/hooks/useProtectedRoute.js
var useProtectedRoute = __webpack_require__(56198);
// EXTERNAL MODULE: ./src/global/MainLayout/index.tsx + 4 modules
var MainLayout = __webpack_require__(53120);
// EXTERNAL MODULE: ./src/global/SEO/index.tsx
var SEO = __webpack_require__(26350);
;// CONCATENATED MODULE: ./pages/watchlist/index.tsx

__webpack_require__(14473);
// features

// hooks

// layouts




function WatchlistPage() {
    (0,useProtectedRoute/* default */.Z)();
    var isSideWidgetOpen = (0,es/* useSelector */.v9)(MainLayout_slice/* selectors */.wl).isSideWidgetOpen;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                title: "Stockbit Watchlist"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLayout["default"], {
                isFlexibleWidth: true,
                maxWidth: isSideWidgetOpen ? 980 : 1280,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(watchlist, {})
            })
        ]
    });
}
/* harmony default export */ var pages_watchlist = (WatchlistPage);


/***/ }),

/***/ 12099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71577);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: inherit;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: unset;\n    color: inherit;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      :hover {\n        transition: 0.2s ease-in;\n        cursor: pointer;\n        background-color: ",
        ";\n        color: ",
        ";\n        border: 1px solid ",
        ";\n      }\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 2px;\n  margin: ",
        ";\n\n  ",
        ";\n\n  :focus,\n  :hover {\n    ",
        "\n  }\n\n  [disabled] {\n    color: ",
        " !important;\n    background-color: ",
        ' !important;\n  }\n\n  [ant-click-animating-without-extra-node="true"]::after,\n  .ant-click-animation-node {\n    --antd-wave-shadow-color: unset;\n  }\n\n  ',
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



var buttonTheme = {
    primary: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light),
    "outline-primary": (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary),
    secondary: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light),
    trading: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject3(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].trading */ .Z.trading, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].trading */ .Z.trading, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light),
    default: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject4(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro),
    borderless: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject5(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light)
};
var Button = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs(function(props) {
    return {
        type: props.type || "default",
        margin: props.margin || "unset",
        isHoverable: props.isHoverable || false
    };
}).withConfig({
    componentId: "sc-878fb425-0"
})(_templateObject7(), function(param) {
    var margin = param.margin;
    return margin;
}, function(param) {
    var type = param.type;
    return buttonTheme[type];
}, function(param) {
    var type = param.type;
    return buttonTheme[type];
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].midgray */ .Z.midgray, function(param) {
    var isHoverable = param.isHoverable;
    return isHoverable && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject6(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro);
});
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 49925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33070);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-content {\n    border-radius: 8px;\n    width: 100%;\n    max-width: ",
        ";\n    margin: auto;\n    overflow-x: ",
        ";\n  }\n\n  .ant-modal-header {\n    border-radius: inherit;\n    border: none;\n    padding-left: 16px;\n  }\n\n  .ant-modal-title {\n    font-size: 20px;\n    font-weight: 700;\n    font-size: 18px;\n    font-weight: 700;\n    cursor: pointer;\n  }\n\n  .ant-modal-body {\n    padding: 0px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Modal = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs(function(props) {
    return {
        footer: null,
        overflowX: props.overflowX || "hidden",
        maxWidth: props.maxWidth || "unset",
        width: props.width || "100%"
    };
}).withConfig({
    componentId: "sc-70c551f7-0"
})(_templateObject(), function(param) {
    var maxWidth = param.maxWidth;
    return maxWidth;
}, function(param) {
    var overflowX = param.overflowX;
    return overflowX;
});
/* harmony default export */ __webpack_exports__["Z"] = (Modal);


/***/ }),

/***/ 57547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2497);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56005);
/* harmony import */ var _slice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67266);
/* eslint-disable react/require-default-props */ 




function ConfirmationModal(param) {
    var children = param.children, isVisible = param.isVisible, title = param.title, _isBlock = param.isBlock, isBlock = _isBlock === void 0 ? false : _isBlock, _confirmText = param.confirmText, confirmText = _confirmText === void 0 ? "Confirm" : _confirmText, onConfirm = param.onConfirm, onCancel = param.onCancel;
    var isCollectionLoading = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_slice__WEBPACK_IMPORTED_MODULE_4__/* .selectors */ .wl).isCollectionLoading;
    var containerPadding = !isBlock && "20px 16px";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_3__/* .Modal */ .u_, {
        visible: isVisible,
        title: title,
        onCancel: onCancel,
        width: "520px",
        centered: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            direction: "column",
            padding: containerPadding,
            children: [
                children,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_3__/* .ButtonContainer */ .qO, {
                    align: "center",
                    justify: "flex-end",
                    // @ts-expect-error
                    mt: "8px",
                    width: "100%",
                    block: isBlock,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_3__/* .ButtonCancel */ .TC, {
                            onClick: onCancel,
                            loading: isCollectionLoading,
                            block: isBlock,
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_3__/* .ButtonConfirm */ .Pw, {
                            onClick: onConfirm,
                            loading: isCollectionLoading,
                            block: isBlock,
                            children: confirmText
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (ConfirmationModal);


/***/ }),

/***/ 67266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CJ": function() { return /* binding */ thunks; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36305);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61876);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68697);
/* harmony import */ var global_AlertMessage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6430);
/* harmony import */ var lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15056);
/* harmony import */ var _selectors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63762);








// utils

// constants
var SLICE_NAME = "collection";
// initial state
var initialState = {
    available: [],
    isDropdownOpen: false,
    isFormOpen: false,
    isCollectionLoading: false,
    error: null,
    needRefresh: false,
    selectedForModify: null,
    modalVisible: "none"
};
var reducers = {
    handleSetDropdown: function(draft, action) {
        draft.isDropdownOpen = action.payload.isOpen;
    },
    handleSetFormOpen: function(draft, action) {
        draft.isFormOpen = action.payload.isOpen;
    },
    handleSelectForModify: function(draft, action) {
        draft.selectedForModify = draft.available[action.payload.selectedIndex];
        draft.modalVisible = action.payload.modalType;
        draft.isDropdownOpen = false;
    }
};
var thunks = {
    createCompanyWatchlist: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)("".concat(SLICE_NAME, "/CREATE_NEW_COMPANY_WATCHLIST"), function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var name, desc, response, _data, error, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        name = param.name, desc = param.desc;
                        _ctx.next = 3;
                        return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__/* ["default"].createNewWatchlist */ .Z.createNewWatchlist(name, desc);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to add watchlist failed!");
                    case 6:
                        _data = response.data, error = _data.error_type, data = _data.data;
                        if (!error) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error(error);
                    case 9:
                        (0,global_AlertMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                            messageType: "success",
                            content: "New watchlist group is added",
                            alertType: "plain"
                        });
                        return _ctx.abrupt("return", {
                            data: data
                        });
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    fetchSavedCompanyWatchlist: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)("".concat(SLICE_NAME, "/FETCH_SAVED_COMPANY_WATCHLIST"), (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, _data, data, error;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getAllWatchlist */ .Z.getAllWatchlist();
                case 2:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 5;
                        break;
                    }
                    throw new Error("Attempt to get saved watchlist failed!");
                case 5:
                    _data = response.data, data = _data.data, error = _data.error_type;
                    if (!error) {
                        _ctx.next = 8;
                        break;
                    }
                    throw new Error(error);
                case 8:
                    return _ctx.abrupt("return", {
                        data: data
                    });
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }))),
    editCompanyWatchlist: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)("".concat(SLICE_NAME, "/EDIT_SELECTED_WATCHLIST"), function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var name, desc, id, response, _data, error, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        name = param.name, desc = param.desc, id = param.id;
                        _ctx.next = 3;
                        return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__/* ["default"].updateWatchlist */ .Z.updateWatchlist(id, name, desc);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to update saved watchlist failed!");
                    case 6:
                        _data = response.data, error = _data.error_type, data = _data.data;
                        if (!error) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error(error);
                    case 9:
                        (0,global_AlertMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                            messageType: "success",
                            content: "Your stock watchlist is updated",
                            alertType: "plain"
                        });
                        return _ctx.abrupt("return", {
                            data: data
                        });
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    deleteCompanyWatchlist: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)("".concat(SLICE_NAME, "/DELETE_SELECTED_WATCHLIST"), function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var id, response, _data, error, data, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        id = param.id;
                        _ctx.next = 3;
                        return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__/* ["default"].deleteWatchlistById */ .Z.deleteWatchlistById(id);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to delete saved watchlist failed!");
                    case 6:
                        _data = response.data, error = _data.error_type, data = _data.data, message = _data.message;
                        if (!error) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error(error);
                    case 9:
                        (0,global_AlertMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                            messageType: "success",
                            content: message,
                            alertType: "plain"
                        });
                        return _ctx.abrupt("return", {
                            data: data,
                            id: id
                        });
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Thunk reducers
var extraReducers = function(builder) {
    // fetchSavedCompanyWatchlist
    builder.addCase(thunks.fetchSavedCompanyWatchlist.pending, function(draft) {
        draft.isCollectionLoading = true;
        draft.needRefresh = false;
    }).addCase(thunks.fetchSavedCompanyWatchlist.fulfilled, function(draft, action) {
        draft.isCollectionLoading = false;
        draft.available = action.payload.data;
    }).addCase(thunks.fetchSavedCompanyWatchlist.rejected, function(draft, action) {
        draft.isCollectionLoading = false;
        draft.error = action.error;
    })// createCompanyWatchlist
    .addCase(thunks.createCompanyWatchlist.pending, function(draft) {
        draft.isCollectionLoading = true;
    }).addCase(thunks.createCompanyWatchlist.fulfilled, function(draft, action) {
        var newWatchlist = action.payload.data;
        if (newWatchlist) {
            draft.available.push(newWatchlist);
        }
        draft.isCollectionLoading = false;
        draft.needRefresh = false;
        draft.isFormOpen = false;
    }).addCase(thunks.createCompanyWatchlist.rejected, function(draft, action) {
        draft.isCollectionLoading = false;
        draft.error = action.error;
    })// editCompanyWatchlist
    .addCase(thunks.editCompanyWatchlist.pending, function(draft) {
        draft.isCollectionLoading = true;
    }).addCase(thunks.editCompanyWatchlist.fulfilled, function(draft) {
        draft.isCollectionLoading = false;
        draft.selectedForModify = null;
        draft.modalVisible = "none";
        draft.needRefresh = true;
    }).addCase(thunks.editCompanyWatchlist.rejected, function(draft, action) {
        draft.isCollectionLoading = false;
        draft.error = action.error;
    })// deleteCompanyWatchlist
    .addCase(thunks.deleteCompanyWatchlist.pending, function(draft) {
        draft.isCollectionLoading = true;
    }).addCase(thunks.deleteCompanyWatchlist.fulfilled, function(draft, action) {
        var id = action.payload.id;
        var newList = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(draft.available);
        var idx = newList.findIndex(function(item) {
            return Number(item.watchlist_id) === Number(id);
        });
        if (idx > -1) {
            newList.splice(idx, 1);
            draft.available = newList;
        }
        draft.isCollectionLoading = false;
        draft.selectedForModify = null;
        draft.modalVisible = "none";
    // draft.needRefresh = true;
    }).addCase(thunks.deleteCompanyWatchlist.rejected, function(draft, action) {
        draft.isCollectionLoading = false;
        draft.error = action.error;
    });
};
// selectors
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSelector */ .P1)(_selectors__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, function(state) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state.collection), {
        activeWatchlistId: state.root.activeWatchlistId,
        activeWatchlistName: state.root.activeWatchlistName
    });
});
var collectionSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSlice */ .oM)({
    initialState: initialState,
    name: SLICE_NAME,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (collectionSlice);


/***/ }),

/***/ 56005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "TC": function() { return /* binding */ ButtonCancel; },
  "Pw": function() { return /* binding */ ButtonConfirm; },
  "qO": function() { return /* binding */ ButtonContainer; },
  "II": function() { return /* binding */ Input; },
  "v2": function() { return /* binding */ styled_Menu; },
  "ti": function() { return /* binding */ MenuHeader; },
  "u_": function() { return /* binding */ styled_Modal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/antd/es/input/index.js + 8 modules
var input = __webpack_require__(7648);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./node_modules/antd/es/menu/index.js + 8 modules
var menu = __webpack_require__(58928);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
;// CONCATENATED MODULE: ./src/@deprecated-ui/watchlist/Menu.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0px;\n\n  li {\n    font-size: 14px;\n    color: ",
        ";\n  }\n\n  li:hover {\n    background: ",
        ";\n    color: ",
        ";\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Menu = (0,styled_components_browser_esm/* default */.ZP)(menu/* default */.Z).withConfig({
    componentId: "sc-e9f945dc-0"
})(_templateObject(), color/* default.highempahis */.Z.highempahis, color/* default.whisper */.Z.whisper, color/* default.primary */.Z.primary);
/* harmony default export */ var watchlist_Menu = (Menu);

// EXTERNAL MODULE: ./src/@deprecated-ui/watchlist/Modal.js
var Modal = __webpack_require__(49925);
// EXTERNAL MODULE: ./src/@deprecated-ui/watchlist/Button.js
var Button = __webpack_require__(12099);
;// CONCATENATED MODULE: ./src/features/watchlist/Collection/styled.ts

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        border-top: solid 1px ",
        ";\n        padding-top: 0px;\n\n        button:first-child {\n          margin-right: 0px;\n        }\n        button {\n          margin: 0px;\n          border: none;\n          /* border-top: 1px solid ",
        "; */\n        }\n      "
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 8px 0 0 0;\n\n  button:first-child {\n    margin-right: 8px;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border: 1px solid rgb(218, 218, 218);\n  border-bottom: none;\n  border-radius: 3px 3px 0 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0px;\n  box-shadow: none;\n  border-left: 1px solid rgb(218, 218, 218) !important;\n  border-right: 1px solid rgb(218, 218, 218) !important;\n  border-top: none;\n  border-bottom: none;\n  padding-left: 4px !important;\n  max-height: 320px;\n  overflow-y: scroll;\n\n  li {\n    font-size: 14px;\n    margin-bottom: 4px !important;\n    display: flex;\n    align-items: center;\n    border-radius: 3px;\n\n    & > span {\n      width: 100%;\n    }\n  }\n\n  li.ant-menu-item.ant-menu-item-only-child {\n    height: 28px;\n    line-height: 22px;\n    color: ",
        ";\n  }\n\n  li.ant-menu-item-selected {\n    background: ",
        " !important;\n  }\n\n  li:hover,\n  li.active {\n    background: ",
        " !important;\n    color: ",
        ";\n    cursor: pointer;\n    border-radius: 3px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-modal-content {\n    border-radius: 3px;\n  }\n\n  .ant-modal-title {\n    font-family: var(--bold-font);\n    font-size: 18px;\n    text-align: center;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-input-suffix {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      color: ",
        ";\n      text-transform: uppercase;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: auto;\n  padding: 10px 24px;\n  text-align: center;\n\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      text-transform: uppercase;\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: ",
        ";\n  border: none;\n  height: auto;\n  padding: 10px 24px;\n\n  &:hover,\n  &:active,\n  &:focus {\n    border: none;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}








// dropdown menu
var ButtonContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-eb5874f9-0"
})(_templateObject1(), // @ts-expect-error
function(param) {
    var block = param.block;
    return block && (0,styled_components_browser_esm/* css */.iv)(styled_templateObject(), color/* default.gainsboro */.Z.gainsboro, color/* default.gainsboro */.Z.gainsboro);
});
var MenuHeader = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
    size: "12px",
    p: "5px 8px",
    height: "20px",
    color: color/* default.midgray */.Z.midgray
}).withConfig({
    componentId: "sc-eb5874f9-1"
})(_templateObject2(), color/* default.light */.Z.light);
var styled_Menu = (0,styled_components_browser_esm/* default */.ZP)(watchlist_Menu).withConfig({
    componentId: "sc-eb5874f9-2"
})(_templateObject3(), color/* default.highempahis */.Z.highempahis, color/* default.whisper */.Z.whisper, color/* default.whisper */.Z.whisper, color/* default.primary */.Z.primary);
var styled_Modal = (0,styled_components_browser_esm/* default */.ZP)(Modal/* default */.Z).withConfig({
    componentId: "sc-eb5874f9-3"
})(_templateObject4());
var Input = (0,styled_components_browser_esm/* default */.ZP)(input/* default */.Z).withConfig({
    componentId: "sc-eb5874f9-4"
})(_templateObject5(), color/* default.lowgray */.Z.lowgray);
var ButtonCancel = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).attrs(// @ts-expect-error
{
    type: "borderless"
}).withConfig({
    componentId: "sc-eb5874f9-5"
})(_templateObject7(), function(param) {
    var block = param.block;
    return !block && (0,styled_components_browser_esm/* css */.iv)(_templateObject6(), color/* default.primary */.Z.primary);
});
var ButtonConfirm = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).attrs({
    type: "primary"
}).withConfig({
    componentId: "sc-eb5874f9-6"
})(_templateObject9(), function(param) {
    var block = param.block;
    return block ? "0px" : "3px";
}, function(param) {
    var block = param.block;
    return !block && (0,styled_components_browser_esm/* css */.iv)(_templateObject8());
});


/***/ }),

/***/ 63762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AW": function() { return /* binding */ activeWlSelector; },
/* harmony export */   "PY": function() { return /* binding */ activeWlNameSelector; },
/* harmony export */   "ki": function() { return /* binding */ tableSelector; }
/* harmony export */ });
/* unused harmony export collectionSelector */
var rootSelector = function(state) {
    return state.watchlist;
};
var collectionSelector = function(state) {
    return state.watchlist.collection;
};
var tableSelector = function(state) {
    return state.watchlist.watchlistTable.table;
};
var activeWlSelector = function(state) {
    return state.watchlist.root.activeWatchlistId;
};
var activeWlNameSelector = function(state) {
    return state.watchlist.root.activeWatchlistName;
};
/* harmony default export */ __webpack_exports__["ZP"] = (rootSelector);


/***/ }),

/***/ 25612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fO": function() { return /* binding */ activeWatchlistIdSelector; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* unused harmony export activeWatchlistNameSelector */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61876);
/* harmony import */ var lib_entities_credentials__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21671);
/* harmony import */ var _selectors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63762);
/* harmony import */ var _Collection_slice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67266);






// constants
var SLICE_NAME = "root";
// initial state
var initialState = {
    activeWatchlistId: null,
    activeWatchlistName: "All Watchlist",
    connectionStatus: "Normal"
};
var reducers = {
    handleChangeActiveWatchlist: function(draft, action) {
        draft.activeWatchlistId = action.payload.selected;
        draft.activeWatchlistName = action.payload.name;
    }
};
// selectors
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSelector */ .P1)(_selectors__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, function(state) {
    var ref, ref1;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state.root), {
        isExpand: ((ref = state.watchlistTable.table.columns) === null || ref === void 0 ? void 0 : ref.length) > 5,
        isComposed: ((ref1 = state.watchlistTable.table.columns) === null || ref1 === void 0 ? void 0 : ref1.length) < 2
    });
});
var activeWatchlistIdSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSelector */ .P1)(_selectors__WEBPACK_IMPORTED_MODULE_3__/* .activeWlSelector */ .AW, function(state) {
    return state;
});
var activeWatchlistNameSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSelector */ .P1)(_selectors__WEBPACK_IMPORTED_MODULE_3__/* .activeWlNameSelector */ .PY, function(state) {
    return state;
});
var extraReducers = function(builder) {
    builder.addCase(_Collection_slice__WEBPACK_IMPORTED_MODULE_1__/* .thunks.editCompanyWatchlist.fulfilled */ .CJ.editCompanyWatchlist.fulfilled, function(state, action) {
        var data = action.payload.data;
        if (data) {
            var id = data.watchlist_id, name = data.name;
            if (state.activeWatchlistId === id) {
                state.activeWatchlistName = name;
            }
        }
    }).addCase(lib_entities_credentials__WEBPACK_IMPORTED_MODULE_0__/* .effects.logout.fulfilled */ .Sz.logout.fulfilled, function(state) {
        // reset active watchlist
        state.activeWatchlistId = null;
        state.activeWatchlistName = "All Watchlist";
    });
};
var rootSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSlice */ .oM)({
    initialState: initialState,
    name: SLICE_NAME,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (rootSlice);


/***/ }),

/***/ 20:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/backpack/1.0.0/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["backpack"]) {
      return resolve(window.remoteLoading["backpack"])
    }

    var res, rej;
    window.remoteLoading["backpack"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["backpack"] !== 'undefined') {
      res(window["backpack"]);
      return resolve(window["backpack"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["backpack"] !== 'undefined') {
          res(window["backpack"]);
          return resolve(window["backpack"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "backpack"
    );
  }).then(function () {
    const proxy = {
      get: backpack.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          backpack.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        backpack.__initialized = true
      }
    }
    if (!backpack.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 17172:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/buy-sell/1.5.4/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["buysell"]) {
      return resolve(window.remoteLoading["buysell"])
    }

    var res, rej;
    window.remoteLoading["buysell"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["buysell"] !== 'undefined') {
      res(window["buysell"]);
      return resolve(window["buysell"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["buysell"] !== 'undefined') {
          res(window["buysell"]);
          return resolve(window["buysell"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "buysell"
    );
  }).then(function () {
    const proxy = {
      get: buysell.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          buysell.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        buysell.__initialized = true
      }
    }
    if (!buysell.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 94673:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/fast-trade/1.1.6/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["fasttrade"]) {
      return resolve(window.remoteLoading["fasttrade"])
    }

    var res, rej;
    window.remoteLoading["fasttrade"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["fasttrade"] !== 'undefined') {
      res(window["fasttrade"]);
      return resolve(window["fasttrade"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["fasttrade"] !== 'undefined') {
          res(window["fasttrade"]);
          return resolve(window["fasttrade"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "fasttrade"
    );
  }).then(function () {
    const proxy = {
      get: fasttrade.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          fasttrade.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        fasttrade.__initialized = true
      }
    }
    if (!fasttrade.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 2680:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/movers/1.0.2/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["movers"]) {
      return resolve(window.remoteLoading["movers"])
    }

    var res, rej;
    window.remoteLoading["movers"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["movers"] !== 'undefined') {
      res(window["movers"]);
      return resolve(window["movers"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["movers"] !== 'undefined') {
          res(window["movers"]);
          return resolve(window["movers"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "movers"
    );
  }).then(function () {
    const proxy = {
      get: movers.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          movers.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        movers.__initialized = true
      }
    }
    if (!movers.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 85611:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/top-stocks/1.0.1/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["topstocks"]) {
      return resolve(window.remoteLoading["topstocks"])
    }

    var res, rej;
    window.remoteLoading["topstocks"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["topstocks"] !== 'undefined') {
      res(window["topstocks"]);
      return resolve(window["topstocks"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["topstocks"] !== 'undefined') {
          res(window["topstocks"]);
          return resolve(window["topstocks"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "topstocks"
    );
  }).then(function () {
    const proxy = {
      get: topstocks.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          topstocks.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        topstocks.__initialized = true
      }
    }
    if (!topstocks.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [74885,63332,25287,94119,78656,71577,88069,46819,97089,25935,7648,80129,51225,50299,73216,2978,52134,91036,54253,54005,33070,58928,83854,44912,21671,74768,12786,77284,8048,49774,92888,40179], function() { return __webpack_exec__(80081); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);